var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKey = function SvgIconKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.8 3.688A5.75 5.75 0 1 1 15 14.75h-.004a5.6 5.6 0 0 1-2.111-.405 1 1 0 0 0-1.105.21l-.944.945H9a1 1 0 0 0-1 1v1.25H6.75a1 1 0 0 0-1 1V20H4v-2.336l5.445-5.444a1 1 0 0 0 .219-1.085 5.6 5.6 0 0 1-.414-2.131V9a5.75 5.75 0 0 1 3.55-5.312m-.843 13.52.791-.792a7.75 7.75 0 1 0-5.164-5.164l-5.291 5.29A1 1 0 0 0 2 17.25V21a1 1 0 0 0 1 1h3.75a1 1 0 0 0 1-1v-1.25H9a1 1 0 0 0 1-1V17.5h1.25a1 1 0 0 0 .707-.293m6.418-10.083a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconKey;